import React, { Component, Fragment, useState, useEffect } from "react";
import PropTypes from "prop-types";
import { withStyles } from "@mui/styles";
import { Dialog, Slide } from "@mui/material";
import { compose } from "recompose";
import styles from "./styles";
import { withSnackbar } from "notistack";
import classNames from "classnames";
import { showSuccessNotification } from "common/helpers";
import { showErrorNotification } from "common/helpers";
import { AddUpdatePmaAdmin } from "services/agent";
import TestHome from "./test-home.jpg";
import { propertyUtil } from "views/Pma/PropertyUtil";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const ErrorModal = (props) => {
  const { handleErrorModal, errorModalText, maxPropertiesNum, missingFields } =
    props;
  console.log("*error modal props", props);
  const { formatSuffix } = propertyUtil;

  const displayCloseText = () => {
    if (errorModalText === "Max properties") {
      return "Ok — Got it";
    } else {
      return "Close";
    }
  };
  const displayErrorText = () => {
    if (errorModalText === "Max properties") {
      return (
        <div className="error-modal-text">
          <p>You have reached the maximum of {maxPropertiesNum} properties.</p>
          <p> Please unselect a property before adding a new one.</p>
        </div>
      );
    } else if (errorModalText === "Min properties") {
      return (
        <div className="error-modal-text">
          <p>Please add another property</p>
          <p>Before removing the last one</p>
        </div>
      );
    } else if (errorModalText === "Max title") {
      return (
        <div className="error-modal-text">
          <p>You have reached the maximum character limit</p>
          <p>Please reduce character count and submit again.</p>
        </div>
      );
    } else if (errorModalText === "Missing inputs") {
      return (
        <div className="error-modal-text">
          <p style={{ width: "200%", fontSize: "18px", fontWeight: "bold" }}>
            Missing Inputs
          </p>
          <p style={{ width: "200%", fontSize: "16px" }}>
            Please fill out the following required fields:
          </p>
          <ul
            style={{
              textAlign: "left",
              margin: "10px 0",
              paddingLeft: "20px",
              listStyleType: "disc",
              width: "200%",
            }}
          >
            {missingFields && missingFields.length > 0 ? (
              missingFields.map((field, index) => (
                <li key={index} style={{ margin: "5px 0" }}>
                  {field}
                </li>
              ))
            ) : (
              <li>All required fields</li>
            )}
          </ul>
        </div>
      );
    } else if (errorModalText === "Missing properties") {
      return (
        <div className="error-modal-text">
          <p>Please select {maxPropertiesNum} properties to display</p>
        </div>
      );
    } else if (errorModalText === "Issue submitting form") {
      return (
        <div className="error-modal-text">
          <p>There was an issue submitting the form</p>
          <p>Please contact ListGen Support</p>
        </div>
      );
    } else if (
      errorModalText &&
      errorModalText.includes("Cannot add duplicate property")
    ) {
      return (
        <div className="error-modal-text">
          <p>{errorModalText}</p>
        </div>
      );
    }
  };
  return (
    <Fragment>
      <Dialog
        open={true}
        //onClose={onCloseFn}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth="lg"
        fullWidth={true}
        TransitionComponent={Transition}
        PaperProps={{
          style: {
            minHeight: "400px",
            maxHeight: "600px",
          },
        }}
      >
        <div className="error-modal-container">
          {displayErrorText()}
          <div className="error-form-button-container">
            <button
              type="button"
              className="error-form-cancel-button"
              onClick={() => handleErrorModal("close")}
            >
              <p>{displayCloseText()}</p>
            </button>
          </div>
        </div>
      </Dialog>
    </Fragment>
  );
};

export default compose(withSnackbar, withStyles(styles))(ErrorModal);
